module.exports = __webpack_public_path__ + "img/logo_pied_de_page.4fa69137.png";